import { render, staticRenderFns } from "./Parametros.vue?vue&type=template&id=5de01dd5"
import script from "./Parametros.vue?vue&type=script&lang=js"
export * from "./Parametros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports